import { render } from "./CustomerInvoiceTable.vue?vue&type=template&id=65cf581f&scoped=true"
import script from "./CustomerInvoiceTable.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceTable.vue?vue&type=script&lang=js"

import "./CustomerInvoiceTable.vue?vue&type=style&index=0&id=65cf581f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cf581f"]])

export default __exports__